// extracted by mini-css-extract-plugin
export default {"layout":"index_layout_CA-Fo"};